// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const body = "ErrorLayout__body__X1xuU";
export const headerButtonWrapper = "ErrorLayout__headerButtonWrapper__H3fd5";
export const title = "ErrorLayout__title__cgTpO font-faces__serifLight__iGPdI font-faces__serif__XseuP";
export const superTitle = "ErrorLayout__superTitle__wWnko";
export const circles = "ErrorLayout__circles__pYAJz";
export const memberCircle = "ErrorLayout__memberCircle__7K2QF";
export const peersCircle = "ErrorLayout__peersCircle__s8Qhp";
export const othersCircle = "ErrorLayout__othersCircle__ZoS7f";
export const text = "ErrorLayout__text__4XA68 font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const buttons = "ErrorLayout__buttons__t1sR7";
export const buttonWrapper = "ErrorLayout__buttonWrapper__YUQ10";